var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3111",
    "data-name": "Rectangle 3111",
    width: 12,
    height: 12,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_104",
    "data-name": "Mask Group 104",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M11.57,13.142a.429.429,0,0,1-.285-.107L7.714,9.858,4.141,13.035a.429.429,0,0,1-.713-.321V2.857A1.716,1.716,0,0,1,5.142,1.143h5.142A1.716,1.716,0,0,1,12,2.857v9.856A.429.429,0,0,1,11.57,13.142Z",
    transform: "translate(-1.714 -1.143)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkWhite);
export default __webpack_public_path__ + "static/media/bookmark_white.bed3acb328b28b5895a1f4514d45df99.svg";
export { ForwardRef as ReactComponent };